import { ControlBar, Container, SeekBar, SeekBarLabel, PlaybackToggleButton, SettingsToggleButton, FullscreenToggleButton, VolumeControlButton } from 'bitmovin-player-ui';
import { createForwardButton, createRewindButton } from '../buttons';
import { createSeekBar } from '../seekbar';
import { createSettingsPanel } from '../settingspanel';
export function createVerticalVideoControlBar(playerContext) {
    const npoPlayer = playerContext.npoplayer;
    const rewindButton = createRewindButton(playerContext);
    const forwardButton = createForwardButton(playerContext);
    const seekBar = new SeekBar({ label: new SeekBarLabel() });
    npoPlayer.uiComponents.seekBar = seekBar;
    const settingsPanel = createSettingsPanel(npoPlayer);
    const settingsContainer = new Container({
        components: [new SettingsToggleButton({ settingsPanel }), settingsPanel],
        cssClasses: ['vertical-video-controlbar-settings']
    });
    const controlBarButtonsContainer = new Container({
        components: [
            new VolumeControlButton({
                vertical: true
            }),
            rewindButton,
            new PlaybackToggleButton(),
            forwardButton,
            new FullscreenToggleButton()
        ],
        cssClasses: ['vertical-video-controlbar-buttons']
    });
    const controlBar = new ControlBar({
        components: [settingsContainer, createSeekBar(npoPlayer), controlBarButtonsContainer],
        cssClasses: ['ui-controlbar-bottom']
    });
    npoPlayer.uiComponents.controlBar = controlBar;
    return controlBar;
}
